import { LoadingButton } from '@mui/lab'
// import { Button } from "@mui/material";
import React from 'react'

export function EmptyPage({ loading, active, activate }) {
  return (
    <div
      className='column column-center'
      style={{
        justifyContent: 'center',
        height: '100vh'
      }}
    >
      <div
        style={{
          width: 760,
          border: '1px solid #DBDBE6',
          borderRadius: '16px',
          background: '#fff'
        }}
        className='row row-center'
      >
        <div
          className='column'
          style={{
            padding: 40,
            alignItems: 'flex-start'
          }}
        >
          <p
            style={{
              fontWeight: 600,
              fontSize: 20,
              lineHeight: '130%',
              marginBottom: 16
            }}
          >
            Stay Ahead of Security Threats
          </p>
          <p
            style={{
              marginBottom: 32
            }}
          >
            Track data leaks related to your company, domain, and employees. Get notified when your data appears in
            public leaks or on the dark web.
          </p>
          <LoadingButton
            loading={loading}
            onClick={activate}
            variant='contained'
            style={{
              background: '#0246F8',
              textTransform: 'none',
              width: 210,
              borderRadius: 12,
              fontFamily: 'Plus Jakarta Sans'
            }}
          >
            {active ? 'Deactivate' : 'Activate'}
          </LoadingButton>
        </div>
        <img src='images/breaches-empty-page-img.png' style={{ width: 360 }} alt='' />
      </div>
    </div>
  )
}
